import { Fade } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as Copy02Icon } from "components/Icons/copy-02.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    icon: {
      color: theme.gray500,
      cursor: "pointer",
      display: "none",
      height: "16px",
      margin: theme.spacing(0, 2),
      width: "16px",
    },
    copied: {
      background: `linear-gradient(90deg, rgba(255, 255, 255, 0), ${theme.white00} 17.5%, ${theme.white00})`,
      color: theme.gray500,
      fontSize: 14,
      marginLeft: "auto",
      padding: theme.spacing(0, 4),
      position: "absolute",
      right: 0,
    },
  }),
);

type CopyWithAlertProps = {
  value?: string;
  canCopy?: boolean;
  className?: string;
  alertVisibility: boolean;
};

export const CopyWithAlert = ({
  value,
  className,
  canCopy = false,
  alertVisibility,
}: CopyWithAlertProps) => {
  const { message } = useMessage();
  const classes = useStyles();

  if (!canCopy || !value) return null;

  return (
    <>
      <Fade
        className={`${classes.copied} ${className ? className : ""}`}
        in={alertVisibility}
        timeout={10}
      >
        <div>{message({ id: "copied!" })}</div>
      </Fade>
      {!alertVisibility && (
        <Copy02Icon className={classes.icon} fontSize="small" />
      )}
    </>
  );
};
